import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SncModalComponent } from './snc-modal.component';
import { ModalModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    ModalModule
  ],
  declarations: [
    SncModalComponent
  ],
  exports: [
    SncModalComponent
  ]
})
export class SncModalModule { }



// WEBPACK FOOTER //
// ./src/app/shared/custom/snc-modal/snc-modal.module.ts